import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权
import { constantRouterMap } from './router'

import EnvBase from '@/env'
const PT = EnvBase.PT

const whiteList = [] // 不重定向白名单

// 从路由表中找到第一个用户有权限访问的页面路径
function findFirstPermittedRoute(permissions) {
    for (const route of constantRouterMap) {
        if (route.hidden || !route.children || route.path === '*' || route.path === '/404') continue
        // 检查父级权限
        if (route.meta && route.meta.permission && !permissions.includes(route.meta.permission)) continue
        // 在 children 中找第一个非隐藏且有权限的子路由
        for (const child of route.children) {
            if (child.hidden) continue
            if (child.meta && child.meta.permission && !permissions.includes(child.meta.permission)) continue
            // 拼接完整路径
            const parentPath = route.path.endsWith('/') ? route.path : route.path + '/'
            const childPath = child.path.startsWith('/') ? child.path : parentPath + child.path
            return childPath
        }
    }
    return '/404'
}

function checkPermission(to, next) {
    if (to.meta && to.meta.permission) {
        const permissions = store.getters.permissions || []
        if (permissions.includes(to.meta.permission)) {
            next()
        } else {
            const firstRoute = findFirstPermittedRoute(permissions)
            if (to.path === firstRoute) {
                next()
            } else {
                Message.error('无权限访问，已跳转到默认页面')
                next(firstRoute)
            }
            NProgress.done()
        }
    } else {
        next()
    }
}

router.beforeEach((to, from, next) => {
    NProgress.start()
    if (getToken()) {
        if (!store.getters.permissions || store.getters.permissions.length === 0) {
            store.dispatch('GetInfo').then(res => { // 拉取用户信息（内部已集成全量权限拉取）
                checkPermission(to, next)
            }).catch(() => {
                store.dispatch('FedLogOut').then(() => {
                    Message.error('验证失败,请重新登录')
                    PT.qnlogin.firstCheck(PT.config.hostBaseUrl) // 跳转统一登录
                })
            })
        } else {
            checkPermission(to, next)
        }
    } else {
        // 允许带着 ticket 的请求进入（由 App.vue 处理验证）
        const ticket = PT.qnlogin.findGetParameter('service_ticket')
        if (ticket) {
            next()
        } else {
            PT.qnlogin.firstCheck(PT.config.hostBaseUrl) // 跳转统一登录
            NProgress.done()
        }
    }
})

router.afterEach(() => {
    NProgress.done() // 结束Progress
})


// WEBPACK FOOTER //
// ./src/permission.js